//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState, mapActions } from "vuex";
import ComponentsUtils from "../../mixins/components-utils";
import Events from "../../mixins/events";
import QFabricModal from "../../../q-fabric-modal.vue";
import QfMScriptEditor from "../script-editor/qf-m-script-editor.vue";

export default {
    name: "QfMApiMapping",
    components: { QfMScriptEditor, QFabricModal },
    mixins: [ComponentsUtils, Events],
    props: {
        mapping: { type: Object, default: () => {} }
    },
    data() {
        return {
            thumbStyle: {
                right: "-7px", borderRadius: "2px", width: "4px", opacity: 0.4
            },
            mappingCategories: [
                { label: "Mapping", value: "map" }
            ],
            mapType: "map",
            localShow: true,
            selectedContract: null,
            isInput: false,
            selectedFunction: null,
            selectedAddreses: null,
            freeAddress: "",
            requestMapping: {},
            responseMapping: {},
            calling: false,
            error: false,
            checked: false,
            showModal: false,
            localValue: null,
            currentEdit: null,
            scriptRequest: { active: false, content: null },
            scriptResponse: { active: false, content: null },
            fromEmit: false,
            mappingList: [],
            requestMappingList: [],
            responseMappingList: []
        };
    },
    computed: {
        ...mapState("components", ["properties", "components"]),
        ...mapGetters("components", ["parsedAPI"]),
        ...mapGetters("diagrams", ["scDetailsFunction"]),

        actions() {
            const actions = [];
            actions.push({ label: "Save", name: "save", disable: !this.selectionDone });
            return actions;
        },
        selectionDone() {
            return this.selectedContract && this.selectedFunction;
        },
        requestTitle() {
            let title;
            if (this.selectionDone) {
                const prmLength = this.requestList.length; let
                    mapped = 0;
                title = prmLength === 1 ? "1 request parameter" : `${prmLength} request parameters`;

                if (this.scriptRequest.active) {
                    title += " (script)";
                } else {
                    Object.values(this.requestMapping).forEach(entry => {
                        if (entry) { mapped++; }
                    });
                    if (mapped === 0) {
                        title += " (no mappings)";
                    } else if (mapped === prmLength) {
                        title += " (all parameters mapped)";
                    } else {
                        title += ` (${mapped} ${mapped === 1 ? "parameter" : "parameters"} mapped)`;
                    }
                }
            } else {
                title = "Please select Contract and Function first...";
            }
            return title;
        },
        responseTitle() {
            let title;
            if (this.selectionDone) {
                const prmLength = this.responseList.length; let
                    mapped = 0;
                title = prmLength === 1 ? "1 response attribute" : `${prmLength} response attributes`;

                if (this.scriptResponse.active) {
                    title += " (script)";
                } else {
                    Object.values(this.responseMapping).forEach(entry => {
                        if (entry) { mapped++; }
                    });
                    if (mapped === 0) {
                        title += " (no mappings)";
                    } else if (mapped === prmLength) {
                        title += " (all responses mapped)";
                    } else {
                        title += ` (${mapped} ${mapped === 1 ? "response" : "responses"} mapped)`;
                    }
                }
            } else {
                title = "Please select Contract and Function first...";
            }
            return title;
        },
        contracts() {
            return this.scDetailsFunction.map(entry => ({ label: entry.name, value: entry.id, functions: entry }));
        },
        functions() {
            let methods = [];
            if (this.selectedContract) {
                const fctToReturn = this.contracts.find(elem => elem.value === this.selectedContract);
                if (fctToReturn) {
                    methods = fctToReturn.functions.functionSignatureDtoList.map(entry => ({ label: entry.name, value: entry.id, parameters: entry }));
                }
            }
            return methods;
        },
        requestList() {
            let requestList = [];

            if (this.selectedContract && this.selectedFunction) {
                const listParams = this.functions.find(fct => fct.value === this.selectedFunction);
                if (listParams) {
                    requestList = listParams.parameters.inParameters || [];
                }
            }
            return requestList;
        },
        responseList() {
            let responseList = [];
            if (this.selectedContract && this.selectedFunction) {
                const listParams = this.functions.find(fct => fct.value === this.selectedFunction);
                if (listParams) {
                    responseList = listParams.parameters.outParameters || [];
                }
            }
            return responseList;
        }
    },
    watch: {
        mapping: {
            handler(val) {
                if (!this.fromEmit) {
                    this.updateLocalMapping(val || {});
                }

                this.fromEmit = false;
            },
            immediate: true
        },
        selectedContract(selectedContract) {
            if (selectedContract) {
                this.selectedFunction = null;
            }
        },
        selectedFunction(selectedFunction) {
            if (selectedFunction) {
                this.updateLocals(selectedFunction);
            } else {
                this.clearRequestResponse();
            }
        }
    },
    created() {
        const obj = {
            param: "FUNCTION",
            responseNull: true,
            fromMetamask: true
        };
        this.mappingList = this.getMappingList();
        console.log(this.mappingList);

        this.getScDetails(obj);
    },
    methods: {
        ...mapActions("diagrams", ["getScDetails"]),
        filterFnRequest(value, update) {
            update(() => {
                this.requestMappingList = this.filterFn(value);
            });
        },
        filterFnResponse(value, update) {
            update(() => {
                this.responseMappingList = this.filterFn(value);
            });
        },
        filterFn(value) {
            let filteredList;
            if (value === "") {
                filteredList = this.mappingList;
            } else {
                const needle = value.toLowerCase();
                filteredList = this.mappingList.filter(({ label }) => label.toLowerCase().indexOf(needle) > -1);
            }
            return filteredList;
        },
        getMappingList() {
            const mappingList = [];

            Object.entries(this.properties).forEach(([key, data]) => {
                const props = data;
                const configProps = this.components[props.__component];
                const isInNamespace = guid => {
                    let done = false; let { parent } = this.properties[guid]; let
                        currentProps;
                    while (parent && !done) {
                        currentProps = this.properties[parent];
                        if (this.components[currentProps.__component].namespace) {
                            done = true;
                        } else {
                            parent = currentProps.parent;
                        }
                    }
                    return done;
                };

                if (configProps.get || configProps.set) {
                    const labelValue = data.label || data.checkLabel || data.toggleLabel || data.code || key;
                    // if (configProps.namespace || isInNamespace((key))) {
                    if (isInNamespace((key))) {
                        // later
                        mappingList.push({
                            label: `[ ].${labelValue}`,
                            value: `${props.parent}[].${props.__generics.code}`,
                            icon: configProps.icon,
                            isDdl: !!props.sort
                        });
                    } else {
                        mappingList.push({
                            label: labelValue,
                            value: props.__generics.code,
                            icon: configProps.icon,
                            isDdl: !!props.sort
                        });
                    }
                }
            });
            return mappingList;
        },
        requestScript(ev, scriptType) {
            const scriptObject = scriptType === "Request" ? this.scriptRequest : this.scriptResponse;

            if (scriptObject.active) {
                this.currentEdit = scriptType;
                this.localValue = scriptObject.content;
                this.showModal = true;
            }

            ev.stopImmediatePropagation();
        },
        changeValue() {
            if (this.isInput) {
                this.selectedAddreses = null;
            } else {
                this.freeAddress = "";
            }
        },
        onUpdate(value) {
            if (this.currentEdit === "Request") {
                this.scriptRequest.content = value;
            } else {
                this.scriptResponse.content = value;
            }
            this.currentEdit = null;
        },
        getMappingObject() {
            const mappingObject = {
                version: 0.2,
                contractId: this.selectedContract,
                contractName: this.contracts.find(elem => elem.value === this.selectedContract).label,
                functionId: this.selectedFunction,
                functionName: this.functions.find(elem => elem.value === this.selectedFunction).label,
                processDefinitionId: this.currentApplicationId,
                contractAddress: this.freeAddress || this.selectedAddreses
            };

            mappingObject._request = { ...this.scriptRequest };
            mappingObject._response = { ...this.scriptResponse };

            mappingObject.request = this.prepareRequestRespone(this.requestMapping);
            mappingObject.response = this.prepareRequestRespone(this.responseMapping);

            return mappingObject;
        },
        prepareRequestRespone(data) {
            const arrayToReturn = [];
            let index = 0;
            Object.entries(data).forEach(([key, value]) => {
                const posIndex = this.mappingList.findIndex(item => item.value === value);
                if (posIndex !== -1) {
                    arrayToReturn.push({
                        index,
                        value,
                        isDdl: this.mappingList[posIndex].isDdl,
                        name: key
                    });

                    index++;
                }
            });
            return arrayToReturn;
        },
        modalAction(action) {
            if (action.simple === "hide") {
                this.localShow = ["action_backdrop", "action_esc"].includes(action.detailed);
            } else if (action.simple === "action") {
                if (action.detailed === "save") {
                    this.fromEmit = true;
                    this.$emit("update", this.getMappingObject());
                    this.localShow = false;
                } else if (action.detailed === "call") {
                    this.testAPICall(this.getMappingObject());
                }
            }
        },
        getRequestObject(mappingObject) {
            const { request } = mappingObject;

            return new Promise(resolve => {
                if (this.scriptRequest.active) {
                    this.__runRequestScript(this.scriptRequest.content).then(data => {
                        resolve(data);
                    });
                } else {
                    const requestObject = {};
                    Object.entries(request).forEach(([key, value]) => {
                        const mapping = this.requestList.find(entry => entry.path === key);
                        const { path } = mapping;

                        this.__addPathValue(requestObject, path, value);
                    });
                    resolve(requestObject);
                }
            });
        },
        testAPICall(mappingObject) {
            this.calling = true;

            this.getRequestObject(mappingObject).then(request => {
                const { api, response } = mappingObject;

                this.__callTestAPI({ api, response, request })
                    .then(({ object = {} }) => {
                        this.calling = false;
                        this.error = false;
                        if (this.scriptResponse.active) {
                            this.__runResponseScript(this.scriptResponse.content, object);
                        } else {
                            Object.keys(this.testResponseMapping).forEach(key => {
                                const mapping = this.responseList.find(entry => entry.path === key);
                                const { path } = mapping;

                                this.testResponseMapping[key] = this.__getPathValue(object, path).data;
                            });
                        }
                    })
                    .catch(() => {
                        this.error = true;
                        this.calling = false;
                    });
            });
        },
        clearRequestResponse() {
            this.requestMapping = {};
            this.responseMapping = {};
        },
        updateLocals() {
            const listParams = this.functions.find(fct => fct.value === this.selectedFunction);
            const request = listParams.parameters.inParameters || [];
            const response = listParams.parameters.outParameters || [];

            this.clearRequestResponse();

            request.forEach(entry => {
                this.$set(this.requestMapping, entry.path, null);
            });

            response.forEach(entry => {
                this.$set(this.responseMapping, entry.path, null);
            });
        },
        updateLocalMapping(val) {
            if (val.contractId && val.functionId) {
                this.selectedContract = val.contractId;
                this.selectedFunction = val.functionId;
                const address = this.mappingList.find(elem => elem.value === val.contractAddress);
                if (address) {
                    this.selectedAddreses = val.contractAddress;
                } else if (val && val.contractAddress) {
                    this.freeAddress = val.contractAddress;
                    this.isInput = true;
                }
            } else {
                this.selectedContract = null;
                this.selectedFunction = null;
            }

            if (val.hasOwnProperty("_request")) { this.scriptRequest = { ...val._request }; }
            if (val.hasOwnProperty("_response")) { this.scriptResponse = { ...val._response }; }

            if (this.selectedContract && this.selectedFunction) {
                const request = val.request && val.request.length ? this.loadRequestResponse(val.request) : val.request;
                const response = val.response && val.response.length ? this.loadRequestResponse(val.response) : val.response;
                this.requestMapping = val.hasOwnProperty("request") ? { ...request } : {};
                this.responseMapping = val.hasOwnProperty("response") ? { ...response } : {};
            } else {
                this.requestMapping = {};
                this.responseMapping = {};
            }
        },
        loadRequestResponse(data) {
            const object = {};
            for (let i = 0; i < data.length; i++) {
                object[data[i].name] = data[i].value;
            }
            return object;
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        modalAfterShow() {}
    }
};
